import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function FinanceAccess({ children }) {
  const { user, workspace } = useAuth();
  const role = workspace?.role || user?.role;
  if (role === "artist") return <Navigate to="/app/artist/finance" replace />;
  if (!["studio_owner", "manager"].includes(role)) return <Navigate to="/app" replace />;
  return children;
}
